import { LockClosedIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

import Typography from '../Typography';

interface Props {
  color: string;
  fontFamily: string;
}

const Premium = ({ color, fontFamily }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center space-x-1">
      <LockClosedIcon
        style={{
          color: color,
        }}
        className="h-3 w-3"
      />
      <Typography as="h2" size={'xs'} fontFamily={fontFamily} weight="bold" color={color}>
        {t('posts.premium')}
      </Typography>
    </div>
  );
};

export default Premium;
